export default function StargatePortal({
  size = 480,
  className = "",
  ticks = 36,
}) {
  const tickMarks = Array.from({ length: ticks }, (_, i) => {
    const a = (i / ticks) * Math.PI * 2;
    const x1 = 200 + Math.cos(a) * 158;
    const y1 = 200 + Math.sin(a) * 158;
    const x2 = 200 + Math.cos(a) * 170;
    const y2 = 200 + Math.sin(a) * 170;
    return (
      <line
        key={i}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke="rgba(167,139,250,0.5)"
        strokeWidth={i % 6 === 0 ? 1.6 : 0.8}
      />
    );
  });

  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true">
      <svg width={size} height={size} viewBox="0 0 400 400" fill="none">
        <defs>
          <radialGradient id="portalGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.25" />
            <stop offset="55%" stopColor="#8B5CF6" stopOpacity="0.06" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="200" cy="200" r="192" fill="url(#portalGlow)" />
        <g className="animate-spin-slow" style={{ transformOrigin: "200px 200px" }}>
          <circle
            cx="200"
            cy="200"
            r="170"
            stroke="rgba(167,139,250,0.35)"
            strokeWidth="1"
            strokeDasharray="1 9"
          />
          {tickMarks}
        </g>
        <g className="animate-spin-reverse" style={{ transformOrigin: "200px 200px" }}>
          <circle
            cx="200"
            cy="200"
            r="128"
            stroke="rgba(56,189,248,0.3)"
            strokeWidth="1"
            strokeDasharray="44 16 6 16"
          />
        </g>
        <circle cx="200" cy="200" r="86" stroke="rgba(240,242,248,0.12)" strokeWidth="1" />
        <circle cx="200" cy="200" r="58" stroke="rgba(139,92,246,0.45)" strokeWidth="1" />
        <circle cx="200" cy="200" r="2.5" fill="#F0F2F8" />
      </svg>
    </div>
  );
}
